import React, { Component } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity, Platform } from "react-native";
import { connect } from "react-redux";
import NewIssue from "../dialogs/newIssue";
import SearchInventory from "./searchInventoryTypes";
import SearchItems from "./searchItems";
import SearchPackaging from "./searchPackagingMaterials";
import colors from "../../constants/colors";
import Swal from "sweetalert2";
import SearchInventoryLocations from "./searchInventoryLocations";
import SearchByProductCode from "./searchByProductCode";
import { getComponentByanotherComponentId, getComponentDefaultSubmit, getComponentSubmissionByDefaultLabel, getComponentSubmit } from "../../utils";
import { getIngredientLotsByName } from "../../actions/submissions";

var filterInterval;

class Input extends Component {

  constructor(props) {
    super(props);
    this.state = {
      //value: props.initial,
      value:  this.props.initial && !(props.isRecipe && props.defaultLabel == "quantity") ? this.props.initial : (props.isRecipe && props.defaultLabel == "quantity") ? getComponentDefaultSubmit(props.components, props.submission, props.defaultLabel, props.id, props.position, props.defaultYield) : "",
      updated: this.props.initial && !(props.isRecipe && props.defaultLabel == "quantity") ? this.props.initial : (props.isRecipe && props.defaultLabel == "quantity") ? getComponentDefaultSubmit(props.components, props.submission, props.defaultLabel, props.id, props.position, props.defaultYield) : "",
      yieldValue: this.props.initial,
      height: 30,
      dialogVisible: false,
      reset: false,
      options: this.props.inventoryLocations ? this.props.inventoryLocations : []
    };
  }
  componentDidMount() {
    const { isInventoryTransfer, defaultLabel, company_id, isRecipe } = this.props;
    const { options } = this.state;
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { defaultLabel, isRecipe } = this.props;

    if (nextProps.initial != this.props.initial && !(isRecipe && defaultLabel == "quantity")) {
      this.setState({ value: nextProps.initial });
    } 
    if (nextProps.batchSizeChanged != this.props.batchSizeChanged && (isRecipe && defaultLabel == "quantity")) {
      this.setState({ value: getComponentDefaultSubmit(this.props.components, nextProps.submission,this.props.defaultLabel, this.props.id, this.props.position, this.props.defaultYield) });
    }
    if (nextProps.inventoryLocations != this.props.inventoryLocations) {
      var options = nextProps.inventoryLocations;
      this.setState({ options: options });
    }
    if (nextProps?.resetInventorySearch) {
      if ((nextProps?.resetInventorySearch?.changed != this.props?.resetInventorySearch?.changed && nextProps?.resetInventorySearch?.position == this.props?.position && this.props?.isShipmentLog && this.props?.defaultLabel == 'item')) {
        this.setState({ value: nextProps.initial, reset: !this.state.reset });
      }
    }
    if (nextProps.initial != this.props.initial && typeof nextProps.initial == "string") {
      this.setState({ updated: nextProps.initial });
    }
  }
  onSelectItem(val, type, item) {
    const { onChange, id } = this.props;
    if (type) {
      if (type == 'lot') {
        this.setState({ value: val?.lot });
      } else {
        if(val?.item){
          this.setState({ value: val?.item });
        }else{
          this.setState({ value: val });
        }
      }
    } else {
      this.setState({ value: val });
    }
    if (item) {
      onChange(id, val, item);
    } else {
      onChange(id, val);
    }
  }
  batchSizeAlert() {
    const { onChange, id } = this.props;
    const { yieldValue, value } = this.state;
    clearInterval(filterInterval);
    Swal.fire({
      text: "Are you sure you want to increase/decrease the ingredients and yield of this recipe?.",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showCancelButton: true,
      confirmButtonColor: colors.orange,
      backdrop: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ yieldValue: value });
        onChange(id, value);
      } else {
        this.setState({ value: yieldValue });
      }
    });
  }
  validateItemStockQty(val) {
    const { id, onChange, defaultLabel, components, submission, inventoryTypes, position } = this.props;
    var valid = true;
    var qtyComponent = components.find(component => component.id == id);
    if (qtyComponent) {
      var lotCodeLabel = defaultLabel == "quantityFinishedGoods" ? "lotcode_finished" : "lotcode_wip";
      var nameComponent = components.find(component => component.section_id == qtyComponent.section_id && component?.defaultLabel == "item");
      var lotComponent = components.find(component => component.section_id == qtyComponent.section_id && component?.defaultLabel == lotCodeLabel);
      if (nameComponent) {
        var itemName = submission[nameComponent.id][position];
        var names = submission[nameComponent.id];
        var lot = submission[lotComponent.id][position] ? submission[lotComponent.id][position] : null;
        var totalQuantity = 0;
        var selectedQuantity = 0;
        //Calculate total quantity
        var item = inventoryTypes.find(inv => inv.item == itemName);
        if (item) {
          item.items.map((itm) => {
            if (itm?.historial) {
              itm.historial.map((historial) => {
                if (historial?.amount > 0) {
                  totalQuantity += historial?.amount;
                }
              });
            }
          });
        } else {
          this.setState({ value: val });
          onChange(id, val);
          return;
        }
        //Calculate selected quantity
        names.map((name, idx) => {
          if (itemName == name && idx != position) {
            var selectedQty = parseFloat(submission[id][idx]);
            if (selectedQty > 0) {
              selectedQuantity += selectedQty;
            }
          }
        });
        var total = parseFloat(val) + selectedQuantity;
        if (total > totalQuantity) {
          valid = false;
        }
      }
    }
    if (valid) {
      this.setState({ value: val });
      onChange(id, val);
    } else {
      this.alertConfirm("The amount available in this lot is insuficient", "Accept");
    }
  }
  alertConfirm(msg, conf) {
    Swal.fire({
      text: msg,
      confirmButtonText: conf,
      confirmButtonColor: '#0B4DA0',
      backdrop: false
    });
  }
  validDecimals(val) {
    var decimals = val.split('.');
    var valid = true;
    if (decimals[1]) {
      if (decimals[1]?.length > 3) {
        valid = false;
      }
    }
    if (decimals.length > 2) valid = false;
    return valid;
  }
  checkForDefaulItems() {
    const { isRecipe, defaultLabel, submission, components, id, position } = this.props;
    var defaultItems = false;
    if (isRecipe && defaultLabel == "location") {
      var comp = components.find(component => component.id == id)
      if (comp) {
        var itemComponent = components.find(component => component.section_id == comp.section_id && component.defaultLabel == "ingredient");
        if (itemComponent) {
          var sub = "";
          if (position || position == 0) {
            sub = submission[itemComponent.id][position];
          } else {
            sub = submission[itemComponent.id];
          }
          if (sub && typeof sub == "string") {
            sub = sub.trim();
            sub = sub.toLocaleLowerCase();
            if (sub == "water") {
              defaultItems = true;
            }
          }
        }
      }
    }

    return defaultItems;
  }
  checkRmLotcodeQty(submission, components, defaultLabel, componentId, position, value) {
    var lotSelected = getComponentSubmit(submission, components, defaultLabel, componentId, position);
    var name = getComponentSubmit(submission, components, "ingredient", componentId, position);
    if (filterInterval) clearInterval(filterInterval);
    if (lotSelected) {
      this.props.getIngredientLotsByName({ name, type: "ingredient" }, (res) => {

        var totalAmount = parseFloat(lotSelected[0].totalAmount) ? lotSelected[0].totalAmount : 0;
        var floatValue = parseFloat(value);

        if (lotSelected == "default_lot") {
          totalAmount = 0;
          if (res?.lots?.length) {
            res.lots.map((lotcode) => {
              if (lotcode?.totalAmount) {
                totalAmount += lotcode.totalAmount;
              }
            });
          }
        }

        if (floatValue <= totalAmount) {
          this.props.onChange(this.props.id, value);
        } else {
          var newQty = floatValue - totalAmount;
          newQty = newQty.toFixed(3);
          if (res?.lots?.length) {
            var newLineLotcode = ["default_lot"];
            res.lots.map((lotcode) => {
              if (lotcode.lot != lotSelected[0]?.lot && newQty <= lotcode.totalAmount && newLineLotcode[0] == "default_lot") {
                newLineLotcode = [lotcode];
              }
            });
            this.qtyAlert(totalAmount.toFixed(3).toString(), newQty, newLineLotcode);
          }
        }
      });

    }

  }
  qtyAlert(totalAmout, newQty, newLineLotcode) {
    const { onChange, id, addRmLine } = this.props;
    const { qtyValue, value } = this.state;
    var name = "";
    if (typeof newLineLotcode[0] == "object") {
      name = newLineLotcode[0]?.lot ? newLineLotcode[0]?.lot : "FIFO";
    } else {
      name = "FIFO";
    }
    if (filterInterval) clearInterval(filterInterval);
    Swal.fire({
      text: 'The selected lot code does not have enough quantity to fulfill the required amount. The remaining quantity will be automatically taken from lot code "' + name.trim() + '" and added to the table.',
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showCancelButton: true,
      confirmButtonColor: colors.orange,
      backdrop: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ value: totalAmout, qtyValue: totalAmout });
        onChange(id, totalAmout);
        if (addRmLine) addRmLine(newQty, newLineLotcode);
        if (filterInterval) clearInterval(filterInterval);
      } else {
        this.setState({ value: qtyValue });
        onChange(id, qtyValue);
        if (filterInterval) clearInterval(filterInterval);
      }
    });
  }
  getUnits(defaultLabel, id, components, submission, position) {

    var units = "";
    var unitsComponent = null;
    if (this.isQuantityComponent(defaultLabel)) {
      unitsComponent = getComponentByanotherComponentId(id, "units", components);
      if(!unitsComponent && this.props.isShipmentLog){
        unitsComponent = getComponentByanotherComponentId(id, "unitsWIP", components);
      }
      //console.log(unitsComponent);
    } else if (defaultLabel == "amount") {
      unitsComponent = getComponentByanotherComponentId(id, "yieldUnits", components);
    }
    else if (defaultLabel == "yield") {
      unitsComponent = components.find((component) => component?.defaultLabel == "yieldUnits");
    }
    if (unitsComponent) {
      units = getComponentSubmissionByDefaultLabel(unitsComponent?.defaultLabel, components, submission, unitsComponent.section_id, position);
      //console.log(units);
      if(typeof units == "object"){
        units = units[0];
      }
    }

    return units;
  }
  isQuantityComponent(defaultLabel){
    return defaultLabel == "quantity" || defaultLabel == "quantityIngredient" || defaultLabel == "quantityFinishedGoods" || defaultLabel == "quantityWIP" || defaultLabel == "quantityPackaging";
  }
  render() {
    const { yieldValue, reset, options, updated } = this.state;
    const { label, onChange, id, isIssuable, onSubmitIssue, isCompleted, placeholder, width, openIssue, defaultComponent, showInventorySearch, showItemsSearch, showPackagingSearch, isRecipe, defaultLabel, showFinishedGoodsSearch, showWorkInProgressSearch, itemInvoice_id, submission, position, isShipmentLog, searchClients, searchSuppliers, isInventoryTransfer, openDropDown, backgroundColor, isLast, showProductCodeSearch, inventoryTypes, isDropDownOpened, closeSearch, resetDropDown, setFocusedInput, focused, components, isInventoryReceivingForm } = this.props;
    const type = defaultLabel == "lotcode_finished" ? "Finished goods" : defaultLabel == "lotcode_wip" ? "Work in progress" : "";
    var value = this.state.value;
    const isQuantityComponent = this.isQuantityComponent(defaultLabel);
    if (isRecipe && defaultLabel == "shelfLife" && typeof value == "object") {
      var newValue = "";
      if (value?.repeat_interval) {
        newValue = value?.repeat_interval;
      }
      if (value?.repeat_interval) {
        newValue += " " + value?.repeat_frequency;
      }
      value = newValue;
    }
    var units = isInventoryReceivingForm ? this.getUnits(defaultLabel, id, components, submission, position) : "";
    return (
      <>
        {!width ?
          <NewIssue
            visible={this.state.dialogVisible}
            id={id}
            label={label}
            onSubmitIssue={onSubmitIssue}
            handleClose={() => {
              this.setState({ dialogVisible: false })
            }}
            width={width}
          /> : null
        }


        <View style={{
          ...styles.container,
          paddingTop: width ? 0 : (isRecipe && (defaultLabel == "yield" || defaultLabel == "amount")) ? 20 : 5,
          flexDirection: (isRecipe && defaultLabel == "yield") ? "row" : "column",
          padding: (isRecipe && (defaultLabel == "yield")) ? 15 : 5,
          marginTop: (isRecipe && (defaultLabel == "yield" || defaultLabel == "amount")) ? 10 : 0,
          flex: 1
        }}>
          {
            (isRecipe && defaultLabel == "yield") ?
              <View style={{ justifyContent: 'center', width: '50%' }}>
                <Text style={{ ...styles.label, fontWeight: '700', color: 'black', marginBottom: 5 }}>{this.props.label}</Text>
                <Text style={{ ...styles.label, fontSize: 12, color: 'black' }}>Enter the desired batch size</Text>
              </View>
              : <Text style={{ ...styles.label, fontWeight: defaultLabel == "productCode" ? '700' : '300', color: defaultLabel == "productCode" ? 'black' : '#939598' }}>{this.props.label}</Text>
          }

          {
            (isIssuable && isCompleted) &&
            <TouchableOpacity style={{ paddingBottom: 10, paddingTop: 5 }} onPress={() => {
              if (width) {
                openIssue();
              } else {
                this.setState({ dialogVisible: true });
              }
            }}>
              <Text style={{ color: colors.primary, fontWeight: 'bold' }}>Issue</Text>
            </TouchableOpacity>
          }
          {
            showItemsSearch &&
            <SearchItems defaultComponent={defaultComponent} onSelectItem={(val, item) => this.onSelectItem(val, 'ingredient', item)} initial={value} isShipmentLog={isShipmentLog} isInventoryTransfer={isInventoryTransfer} placeholder={"Enter text to search items"} width={width} closeSearch={closeSearch} isRecipe={isRecipe} resetDropDown={resetDropDown}
              onFocus={() => {
                if (isRecipe) {
                  if (setFocusedInput) setFocusedInput();
                }
              }} defaultLabel={defaultLabel} isInventoryReceivingForm={isInventoryReceivingForm}/>
          }
          {
            showInventorySearch &&
            <SearchInventory resetDropDown={resetDropDown} defaultComponent={defaultComponent} onSelectItem={(val, item) => this.onSelectItem(val, 'lot', item)} initial={value} type={type} searchBy={'lot'} isShipmentLog={isShipmentLog} defaultLabel={defaultLabel} reset={reset} width={width} openDropDown={openDropDown} backgroundColor={backgroundColor} isLast={isLast} isDropDownOpened={isDropDownOpened} closeSearch={closeSearch}
              onFocus={() => {
                if (isRecipe) {
                  if (setFocusedInput) setFocusedInput();
                }
              }}
            />
          }{
            showPackagingSearch &&
            <SearchPackaging defaultComponent={defaultComponent} onSelectItem={(val, item) => this.onSelectItem(val, null, item)} initial={value} width={width} isInventoryTransfer={isInventoryTransfer} isRecipe={isRecipe} isShipmentLog={isShipmentLog}
              onFocus={() => {
                if (isRecipe) {
                  if (setFocusedInput) setFocusedInput();
                }
              }} defaultLabel={defaultLabel} isInventoryReceivingForm={isInventoryReceivingForm} closeSearch={closeSearch} resetDropDown={resetDropDown}/>
          }
          {
            showFinishedGoodsSearch &&
            <SearchInventory resetDropDown={resetDropDown} defaultComponent={defaultComponent} onSelectItem={(val, item) => this.onSelectItem(val, 'item', item)} initial={value} type={'Finished goods'} isInventoryTransfer={isInventoryTransfer} searchBy={'item'} itemInvoice_id={itemInvoice_id} submission={submission} position={position} isShipmentLog={isShipmentLog} defaultLabel={defaultLabel} reset={reset} width={width} openDropDown={openDropDown} backgroundColor={backgroundColor} isLast={isLast} isDropDownOpened={isDropDownOpened} closeSearch={closeSearch}
              onFocus={() => {
                if (isRecipe) {
                  if (setFocusedInput) setFocusedInput();
                }
              }} isInventoryReceivingForm={isInventoryReceivingForm}
            />
          }
          {
            showWorkInProgressSearch &&
            <SearchInventory resetDropDown={resetDropDown} defaultComponent={defaultComponent} onSelectItem={(val, item) => this.onSelectItem(val, 'item', item)} initial={value} type={'Work in progress'} isInventoryTransfer={isInventoryTransfer} searchBy={'item'} itemInvoice_id={itemInvoice_id} submission={submission} position={position} isShipmentLog={isShipmentLog} defaultLabel={defaultLabel} reset={reset} width={width} openDropDown={openDropDown} backgroundColor={backgroundColor} isLast={isLast} isDropDownOpened={isDropDownOpened} closeSearch={closeSearch}
              onFocus={() => {
                if (isRecipe) {
                  if (setFocusedInput) setFocusedInput();
                }
              }} isInventoryReceivingForm={isInventoryReceivingForm}
            />
          }
          {
            searchClients &&
            <SearchItems defaultComponent={defaultComponent} onSelectItem={(val) => this.onSelectItem(val)} initial={value} customers={true} placeholder={"Enter text to search customers"} width={width} closeSearch={closeSearch} isRecipe={isRecipe} resetDropDown={resetDropDown}
              onFocus={() => {
                if (isRecipe) {
                  if (setFocusedInput) setFocusedInput();
                }
              }}
            />
          }
          {
            searchSuppliers &&
            <SearchItems defaultComponent={defaultComponent} onSelectItem={(val) => this.onSelectItem(val)} initial={value} suppliers={true} placeholder={"Enter text to search suppliers"} width={width} closeSearch={closeSearch} isRecipe={isRecipe} resetDropDown={resetDropDown}
              onFocus={() => {
                if (isRecipe) {
                  if (setFocusedInput) setFocusedInput();
                }
              }}
            />
          }
          {
            (isInventoryTransfer && (defaultLabel == "fromLocation" || defaultLabel == "toLocation")) &&
            <SearchInventoryLocations resetDropDown={resetDropDown} defaultComponent={defaultComponent} onSelectItem={(val) => this.onSelectItem(val)} initial={value} updated={updated} options={options} placeholder={"Enter text to search locations"} width={width} isRecipe={false} openDropDown={openDropDown} backgroundColor={backgroundColor} isLast={isLast} defaultLabel={defaultLabel} isDropDownOpened={isDropDownOpened} closeSearch={closeSearch}
              onFocus={() => {
                if (isRecipe) {
                  if (setFocusedInput) setFocusedInput();
                }
              }}
            />
          }
          {
            (isRecipe && (defaultLabel == "location") && !this.checkForDefaulItems()) &&
            <SearchInventoryLocations resetDropDown={resetDropDown} defaultComponent={defaultComponent} onSelectItem={(val) => this.onSelectItem(val)} initial={value} options={options} placeholder={"Enter text to search locations"} width={width} isRecipe={isRecipe} openDropDown={openDropDown} backgroundColor={backgroundColor} isLast={isLast} isDropDownOpened={isDropDownOpened} closeSearch={closeSearch}
              onFocus={() => {
                if (isRecipe) {
                  if (setFocusedInput) setFocusedInput();
                }
              }}
            />
          }
          {
            showProductCodeSearch &&
            <SearchByProductCode defaultComponent={defaultComponent} onSelectItem={(val, item) => this.onSelectItem(val, null, item)} initial={value} placeholder={"Enter text to search items"} width={width} type={defaultLabel} inventoryTypes={inventoryTypes} isShipmentLog={isShipmentLog} closeSearch={closeSearch} isInventoryTransfer={isInventoryTransfer} resetDropDown={resetDropDown}
              onFocus={() => {
                if (isRecipe) {
                  if (setFocusedInput) setFocusedInput();
                }
              }}
            isInventoryReceivingForm={isInventoryReceivingForm}/>
          }
          {
            !showProductCodeSearch && !showItemsSearch && !showInventorySearch && !showPackagingSearch && !showFinishedGoodsSearch && !showWorkInProgressSearch && !searchClients && !searchSuppliers && !(isInventoryTransfer && (defaultLabel == "fromLocation" || defaultLabel == "toLocation")) && !(isRecipe && (defaultLabel == "location")) &&
            <View style={{ flexDirection: 'row',
              borderWidth: isRecipe && (defaultLabel == "yield" || defaultLabel == "amount") ? 1 : 0,
              borderRadius: (isRecipe && defaultLabel == "yield" || defaultLabel == "amount") ? 10 : 0,
              paddingInline: (isRecipe && defaultLabel == "yield" || defaultLabel == "amount") ? 5 : 0,
              paddingVertical: (isRecipe && defaultLabel == "yield" || defaultLabel == "amount") ? 10 : 0,
              paddingTop: (isRecipe && defaultLabel == "yield" || defaultLabel == "amount") ? 10 : 0,
              marginInline: (isRecipe && defaultLabel == "yield" || defaultLabel == "amount") ? 10 : 0,
              width: (isRecipe && defaultLabel == "yield") && '50%',
              borderColor: colors.orange,
             }}>
              <TextInput
                value={value}
                editable={!defaultComponent}
                onContentSizeChange={(event) => {
                  if (event.nativeEvent.contentSize.height == 0) {
                    if (this.props.placeholder == '') {
                      this.setState({ height: 30 })
                    }
                    this.setState({ height: event.nativeEvent.contentSize.height });
                  } else {
                    setTimeout(() => {
                      this.setState({ height: event.nativeEvent.contentSize.height });
                    }, 5)
                  }
                }}
                onFocus={() => {
                  if (isRecipe) {
                    if (setFocusedInput) setFocusedInput();
                  }
                }}
                style={{
                  ...styles.input,
                  borderRadius: 5,
                  borderWidth: focused && (isInventoryReceivingForm && isQuantityComponent) ? 2 : ((isRecipe && defaultLabel == "yield") || (isRecipe && width && defaultLabel != "preparationInstructions")) ? 0 : 1,
                  color: isRecipe && (defaultLabel == "yield" || defaultLabel == "amount") ? colors.orange : "#424242",
                  fontFamily: "Roboto",
                  fontWeight: "400",
                  padding: 5,
                  height: this.state.height,
                  fontStyle: this.state.value ? this.state.value.length == 0 ? 'italic' : 'normal' : 'normal',
                  borderColor: "#e7e7e7",
                  fontSize: isInventoryReceivingForm ? 16 : 20,
                  flex: isInventoryReceivingForm && !(isRecipe && defaultLabel == "yield") ? 3 : 1,
                  overflow: 'hidden',
                  textAlign: isInventoryReceivingForm && (isQuantityComponent || defaultLabel == "yield" || defaultLabel == "amount") ? 'center' : 'left',
                }}
                multiline={true}
                placeholder={this.props.placeholder}
                placeholderTextColor={'rgb(0, 47, 108)'}
                onChangeText={(val) => {
                  if (isRecipe && (defaultLabel == "yield" || defaultLabel == "quantity")) {
                    var formated = val.trim();
                    if (formated == '' && this.props.placeholder == '') {
                      clearInterval(filterInterval);
                      this.setState({ value: formated, height: 30 });
                    } else {
                      if (formated == '') {
                        clearInterval(filterInterval);
                        this.setState({ value: formated, yieldValue: formated });
                      } else {
                        this.setState({ value: formated }, () => {
                          clearInterval(filterInterval);
                          //filterInterval = setInterval(() => this.batchSizeAlert(), 2500);
                          if (defaultLabel == "yield") {
                            filterInterval = setInterval(() => this.batchSizeAlert(), 2500);
                          } else if (defaultLabel == "quantity") {
                            filterInterval = setInterval(() => this.checkRmLotcodeQty(submission, components, "lotcode", id, position, formated), 2500);
                          }
                        });
                      }

                    }
                  } else {
                    //if(isShipmentLog && (defaultLabel == "quantityFinishedGoods" || defaultLabel == "quantityWIP")){
                    //  if (val == '' && this.props.placeholder == '') {
                    //    this.setState({ value: val, height: 30 });
                    //  } else {
                    //    this.validateItemStockQty(val);
                    //  }
                    //}else {
                    if (isInventoryTransfer && defaultLabel == "quantity") {
                      if (!this.validDecimals(val)) return;
                    }

                    if (val == '' && this.props.placeholder == '') {
                      this.setState({ value: val, height: 30 });
                    } else {
                      this.setState({ value: val });
                    }
                    if(isQuantityComponent){
                      onChange(id, val, null, true);
                    }
                    onChange(id, val);
                    //}
                  }
                }}
              />
              {(isInventoryReceivingForm && units) && <View style={{ ...styles.unitsContainer }}><Text style={{ textAlign: 'center' }}>{(defaultLabel == "yield" || defaultLabel == "amount") ? '('+units+')' : units}</Text></View>}
            </View>
          }
        </View>
      </>

    );
  }
}
export default connect((state, ownProps = {}) => ({
  company_id: state.user.get("company_id"),
}), (dispatch, props) => ({
  getIngredientLotsByName: (data, callback) => {
    dispatch(getIngredientLotsByName(data, callback))
  },
  dispatch: dispatch,
}))(Input);

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    // paddingBottom: 10,
    // paddingHorizontal: 10,
    paddingTop: 5,
  },
  input: {
    borderColor: "#e7e7e7",
    borderRadius: 5,
    borderWidth: 1,
    color: "#424242",
    fontFamily: "Roboto",
    fontSize: 22,
    fontWeight: "400",
    paddingLeft: 10,
  },
  label: {
    fontSize: 20,
    color: '#939598',
    fontWeight: '300',
    fontFamily: 'Roboto',
  },
  unitsContainer: {
    flex: 2, justifyContent: 'center', alignItems: 'left', padding: 3
  }
});
